<div class="cell auto">
    {{labelKey | translate}}
</div>
<div class="cell shrink" *ngIf="loading">
    <i class="fas fa-circle-notch fa-spin"></i>
</div>
